import React from "react";
import { CheckBox, Page } from "../../../helbest";
import Header from "../Cart/Header/Header";
import styles from "./Invoices.module.css";

import { ReactComponent as TickIcon } from "./../../../assets/svg/tick.svg";
import { ReactComponent as CancelIcon } from "./../../../assets/svg/cancel.svg";
import { ReactComponent as UploadIcon } from "./../../../assets/svg/upload.svg";
import { useState } from "react";
import { useEffect } from "react";
import produce from "immer";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Row from "./Row/Row";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
// import { useMyInvoicesQuery } from "../../../saleor/api";
// import { mapEdgesToNodes } from "../../../base/utils";
// import { InvoiceListTransformer } from "../../../base/objectTransformers/invoices";

const Invoices = () => {
  // const { data } = useMyInvoicesQuery();

  const [invoiceList, setInvoiceList] = useState([]);
  const [selectAll, setSelecteAll] = useState(false);

  const allFalse = invoiceList.every((item) => !item.checked);

  // useEffect(() => {
  //     if (data?.me?.orders?.edges?.length) {
  //         const invoices = mapEdgesToNodes(data?.me?.orders?.edges, InvoiceListTransformer)
  //         setInvoiceList(invoices);
  //     }
  // }, [data])

  useEffect(() => {
    if (invoiceList.length && selectAll) {
      setInvoiceList(
        produce((draft) => {
          draft.forEach((_, draftIndex) => {
            draft[draftIndex].checked = selectAll;
          });
        })
      );
    }
  }, [selectAll, invoiceList.length]);

  return (
    <Page
      className={`page-cart ${styles.InvoicesPageContent}`}
      title="Cart"
      footer={<></>}
      showFooter
      mobileContainer
      customHeader={<HeaderBack title={"Invoices"} url={"/profile"} />}
      headerFix
      logo
      back
      address="/"
    >
      <div
        style={{ backgroundColor: "#FAFAFA" }}
        className="w-full flex justify-start items-center p-4"
      >
        <div
          onClick={() => {
            const unit = "pt";
            const size = "A4";
            const orientation = "portrait";

            const marginLeft = 40;
            const doc = new jsPDF(orientation, unit, size);

            doc.setFontSize(15);

            const title = "Invoices";
            const headers = [["Invoice", "Date", "Status"]];

            const data = invoiceList
              .filter((elt) => elt.checked)
              .map((elt) => [
                elt.invoice,
                elt.date,
                elt.passed ? "paid" : "canceled",
              ]);

            let content = {
              startY: 50,
              head: headers,
              body: data,
            };

            doc.text(title, marginLeft, 40);
            doc.autoTable(content);
            doc.save("invoices.pdf");
          }}
          className={`${styles.DownloadButton} ${
            allFalse ? styles.Disabled : ""
          }`}
        >
          <div className={styles.DownloadButtonIconContainer}>
            <UploadIcon />
          </div>
          <span>PDF</span>
        </div>
        <div
          onClick={() => {
            let csvContent = "data:text/csv;charset=utf-8,";
            const all_keywords_columns = ["invoice", "Date", "Status"];
            all_keywords_columns.forEach((col, colIndex) => {
              csvContent +=
                col + (colIndex === all_keywords_columns.length - 1 ? "" : ",");
            });
            csvContent += "\n";
            invoiceList.forEach((invoiceItem) => {
              if (invoiceItem.checked) {
                csvContent += invoiceItem.invoice + ",";
                csvContent += invoiceItem.date + ",";
                csvContent += invoiceItem.passed ? "passed" : "canceled";
                csvContent += "\n";
              }
            });
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", `invoices.csv`);
            document.body.appendChild(link);
            link.click();
          }}
          className={`${styles.DownloadButton} ${
            allFalse ? styles.Disabled : ""
          }`}
        >
          <div className={styles.DownloadButtonIconContainer}>
            <UploadIcon />
          </div>
          <span>CSV</span>
        </div>
      </div>
      <table className={styles.Table}>
        <tr>
          <th>
            <div className={styles.InvoiceHeader}>
              <CheckBox
                checked={selectAll}
                onChange={(newValue) => setSelecteAll(newValue.target.checked)}
              />
              <div>Invoice</div>
            </div>
          </th>
          <th>
            <div className={styles.InvoiceHeader}>Date</div>
          </th>
          <th>
            <div className={styles.InvoiceHeader}>Status</div>
          </th>
        </tr>
        {invoiceList.map((invoiceItem, invoiceIndex) => {
          return (
            <Row
              key={invoiceIndex}
              icon={invoiceItem.passed ? TickIcon : CancelIcon}
              invoice={invoiceItem.invoice}
              checked={invoiceItem.checked}
              date={invoiceItem.date}
              passed={invoiceItem.passed}
              setInvoiceList={setInvoiceList}
              invoiceIndex={invoiceIndex}
            />
          );
        })}
      </table>
    </Page>
  );
};

export default Invoices;
